var CryptoJS = require("crypto-js");

const privateKey = ""; // Could use a date or something dynamic

const normalizeText = (value: unknown) => {
  if (value === null || value === undefined) {
   return "";
  }

  if (typeof value === "string") {
   return value;
  }

  if (typeof value === "number" || typeof value === "boolean") {
   return String(value);
  }

  try {
   return JSON.stringify(value);
  } catch (error) {
   return String(value);
  }
};

const getEnvKey = (keyName: string, fallback: string) => {
  const value = process.env[keyName];
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
};

export function AESEncrypt(pureText: string) {
  const safeText = normalizeText(pureText);
  const key = CryptoJS.enc.Utf8.parse(
    getEnvKey("REACT_APP_ENCRYPT_KEY", "SldzbmFYWjRGeAxs")
  );

  const ciphertext = CryptoJS.AES.encrypt(safeText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return encodeURIComponent(ciphertext);
}

export function Base64Encode(pureText: string) {
  var cipherText = btoa(pureText);
  return cipherText;
}

export function AESDecrypt(encryptedText?: string) {
  try {
   if (encryptedText) {
     const key = CryptoJS.enc.Utf8.parse(
       getEnvKey("REACT_APP_ENCRYPT_KEY", "SldzbmFYWjRGeAxs")
     );

     const bytes = CryptoJS.AES.decrypt(
       decodeURIComponent(encryptedText),
       key,
       {
         mode: CryptoJS.mode.ECB,
         padding: CryptoJS.pad.Pkcs7,
       }
     );

     const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
     if (!decryptedText) {
       return encryptedText;
     }

     try {
       return JSON.parse(decryptedText);
     } catch (e) {
       return decryptedText;
     }
   }
   return "";
  } catch (e) {
   return encryptedText;
  }
}

const secretKey = "";

export function AESEncryptforDashboard(plainText: string | number | boolean | object | null | undefined) {
  const normalizedPlainText = normalizeText(plainText);
  const key = CryptoJS.enc.Utf8.parse(
   getEnvKey("REACT_APP_DASHBOARD_KEY", "SldzbmFYWjRGeAxs")
  );
  const encrypted = CryptoJS.AES.encrypt(normalizedPlainText, key, {
   mode: CryptoJS.mode.ECB,
   padding: CryptoJS.pad.Pkcs7,
  });

  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  return encryptedBase64;
}

export function encryptAndEncode(plainText: string | number | undefined | null) {
    if(plainText === undefined || plainText === null) {
      return "";
    }
    if(typeof plainText === "number") {
      plainText = plainText.toString();
    }
    const encrypted = AESEncrypt(plainText);
    const encoded = Base64Encode(encrypted);
    return encoded;
}

export function AESEncryptAny(value: any) {
  return AESEncrypt(JSON.stringify(value));
}

export function AESDecryptAny(cipherText: any) {
  if (!cipherText) {
    return null;
  }

  try {
    return JSON.parse(cipherText);
  } catch (e) {
    const decrypted = AESDecrypt(cipherText);

    try {
      return JSON.parse(decrypted);
    } catch (e) {
      return decrypted;
    }
  }
}
